import { jwtDecode } from 'jwt-decode';
import { type HttpClient } from '../HttpClient';

type DecodedToken = {
    meeting_id: string;
    connection_id: string;
    class_id: string;
    class_uuid: string;
    class_session_uuid: string;
    user_uuid: string;
    student_id: string;
};

export const getTokenProperty = (token: HttpClient['token'], propertyName: keyof DecodedToken) => {
    if (!token) {
        return null;
    }

    try {
        const decoded = jwtDecode<DecodedToken>(token);

        return decoded[propertyName];
    } catch (error) {
        console.error('Invalid token', error);

        return null;
    }
};
